<template>
    <div class="control-group">
        <div class="control-label"><Label :description="description" :label="label"></Label></div>
        <div class="controls">
            <input class="form-control"
                    :name="name"
                    v-bind:value="value"
                    v-on:input="$emit('update:value', $event.target.value)"
            >
        </div>
    </div>
</template>

<script>
    import Label from "./Label";

    export default {
        components: {
            Label
        },
        props: {
            name: null,
            label: null,
            description: null,
            value: null,
            defaultValue: null
        },
        data() {
            return {
            };
        },
        mounted() {
            this.$emit('update:value', this.defaultValue)
        },
        methods: {
        }
    };
</script>
